import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/api/auth.service';

@Injectable({
  providedIn: 'root',
})
export class FurnitureService {
  backendUrlBase = environment.backendUrl + 'api/Mr';

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {}
}
